export default __webpack_public_path__ + "static/media/alldetails.75b4d0cd18a77cf54f996f8a860ee6dc.svg";